import { useState } from "react"
import styles from "../../../styles/Participant-Employment.module.css"
import CheckboxField from "../Utils/CheckboxField"
import { useEffect } from "react"
const CheckboxForm = ({ label, setValue, valueName, value }) => {
  const [selected, setSelected] = useState({
    combatRelated: value?.combatRelated,
    housing: value?.housing,
    medicare: value?.medicare,
    retirement: value?.retirement,
    ssi: value?.ssi,
    other: value?.other,
    foodStamps: value?.foodStamps,
    medicaid: value?.medicaid,
    nonCombat: value?.nonCombat,
    ssdi: value?.ssdi,
    tanf: value?.tanf,
  })

  useEffect(() => {
    setValue(valueName, selected)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected])

  return (
    <>
      <label className={styles.label}>{label}</label>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flexBasis: "100%",
            flex: "1",
            color: "#383838",
          }}
        >
          <CheckboxField
            label={"Combat-related VA benefits"}
            value={selected}
            setValue={setSelected}
            valueName={"combatRelated"}
          />
          <CheckboxField
            label={"Housing Subsidy"}
            value={selected}
            setValue={setSelected}
            valueName={"housing"}
          />
          <CheckboxField
            label={"Medicare"}
            value={selected}
            setValue={setSelected}
            valueName={"medicare"}
          />
          <CheckboxField
            label={"Retirement"}
            value={selected}
            setValue={setSelected}
            valueName={"retirement"}
          />
          <CheckboxField
            label={"SSI"}
            value={selected}
            setValue={setSelected}
            valueName={"ssi"}
          />
          <CheckboxField
            label={"Other"}
            value={selected}
            setValue={setSelected}
            valueName={"other"}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flexBasis: "100%",
            flex: "1",
            color: "#383838",
          }}
        >
          <CheckboxField
            label={"Food Stamps/SNAP"}
            value={selected}
            setValue={setSelected}
            valueName={"foodStamps"}
          />
          <CheckboxField
            label={"Medicaid"}
            value={selected}
            setValue={setSelected}
            valueName={"medicaid"}
          />
          <CheckboxField
            label={"Non-combat VA Benefits"}
            value={selected}
            setValue={setSelected}
            valueName={"nonCombat"}
          />
          <CheckboxField
            label={"SSDI"}
            value={selected}
            setValue={setSelected}
            valueName={"ssdi"}
          />
          <CheckboxField
            label={"TANF"}
            value={selected}
            setValue={setSelected}
            valueName={"tanf"}
          />
        </div>
      </div>
    </>
  )
}
export default CheckboxForm
